import React from 'react';
import { Text } from '../Text/Text';
export const Heading = props => React.createElement(Text, {
  as: 'h3',
  ...props
});
Heading.displayName = 'Heading';
Heading.h1 = props => React.createElement(Heading, {
  as: 'h1',
  textShadowSize: 'md',
  ...props
});
Heading.h2 = props => React.createElement(Heading, {
  as: 'h2',
  textShadowSize: 'md',
  ...props
});
Heading.h3 = props => React.createElement(Heading, {
  as: 'h3',
  textShadowSize: 'sm',
  ...props
});
Heading.h4 = props => React.createElement(Heading, {
  as: 'h4',
  textShadowSize: 'sm',
  ...props
});
Heading.h5 = props => React.createElement(Heading, {
  as: 'h5',
  textShadowSize: 'sm',
  ...props
});
Heading.h6 = props => React.createElement(Heading, {
  as: 'h6',
  textShadowSize: 'sm',
  ...props
});